// extracted by css-extract-rspack-plugin
export default {"section":"section-KWRCQ1","label":"label-OdsHKr"};